<template>
  <ob-admin-section
    type="storage"
    has-perioade
    import-headers-btn
    :xlsx="false"
    :add="false"
    :edit="false"
    :confirm-value="confirm.dialog"
    @confirmed="_cbConfirmed"
    @itemsSelected="_cbItemsSelected">

    <template slot="section-title">Sectiune Arhiva fisiere xlsx</template>

    <template slot="toolbar-title">Baza de date Sectiune Arhiva fisiere xlsx</template>

    <template slot="fab">
      <v-speed-dial
        class="ob-speed-dial"
        v-model="fab"
        absolute
        fixed
        bottom
        right
        direction="top"
        open-on-hover
        transition="scroll-y-reverse-transition"
        key="speeddial">
        <v-btn
          slot="activator"
          v-model="fab"
          color="accent"
          dark
          fab
          key="speed">
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="success"
              @click="_cbDownloadToDevice">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </span>
          <span>{{ selected.length ? `Descarca ${selected.length} pe device` : 'Descarca toate fisierele pe device' }}</span>
        </v-tooltip>
      </v-speed-dial>
    </template>
  </ob-admin-section>
</template>

<script>
import streamSaver from 'streamsaver'

import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'

export default {
  name: 'storage',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'storage',
    fab: null,
    selected: [],
    confirm: {
      dialog: false,
      callback: null
    }
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    perioadeTabs () {
      return this.$store.getters[`${this.type}/perioadeTabs`]
    },
    selectedPerioadeTab () {
      return this.$store.getters[`${this.type}/selectedPerioadeTab`]
    }
  },
  methods: {
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    _cbItemsSelected (items) {
      this.selected = items
    },
    async _cbDownloadToDevice () {
      try {
        if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
          streamSaver.mitm = `${this.host}/mitm.html`
        }
        const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_${this.selected.length || ''}_Nomenclatoare.zip`)
        const response = await fetch(`${this.host}/download-storage`, {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.token
          }),
          body: JSON.stringify({ storageIds: this.selected, perioada: this.perioadeTabs[this.selectedPerioadeTab]._id })
        })

        // more optimized
        if (response.body.pipeTo) {
          return response.body.pipeTo(fileStream).then(() => console.log('done writing'))
        }

        const writer = fileStream.getWriter()
        const reader = response.body.getReader()
        const pump = () => reader.read().then(({ value, done }) => {
          if (done) {
            // close the stream so we stop writing
            writer.close()
          } else {
            // Write one chunk, then get the next one
            writer.write(value).then(pump)
          }
        })

        // Start the reader
        pump()
      } catch (e) {
        console.error(e)
      }
    }
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchHeaders`)
    this.$store.dispatch(`${this.type}/fetchItems`)
    this.$store.dispatch(`${this.type}/fetchPerioadeTabs`)
  }
}
</script>

<style>

</style>
